import { cn } from '@/shared/lib/utils'

type BadgeVariant = 'active' | 'draft' | 'syncing' | 'error' | 'archived' | 'module'

const variantClasses: Record<Exclude<BadgeVariant, 'module'>, string> = {
  active: 'bg-gold-light text-gold-dark border border-gold/20',
  draft: 'bg-paper-warm text-ink-muted border border-ink-border',
  syncing: 'bg-teal-light text-teal-dark border border-teal/20 animate-gold-pulse',
  error: 'bg-brick-light text-brick-dark border border-brick/20',
  archived: 'bg-paper-warm text-ink-faint border border-ink-border',
}

const moduleColors: Record<string, string> = {
  sdi: 'bg-teal-light text-teal-dark border border-teal/20',
  llr: 'bg-gold-light text-gold-dark border border-gold/20',
  are: 'bg-brick-light text-brick-dark border border-brick/20',
  gfo: 'bg-purple-50 text-purple-700 border border-purple-200',
}

interface BadgeProps {
  variant: BadgeVariant
  moduleId?: string
  children: React.ReactNode
  className?: string
}

export function Badge({ variant, moduleId, children, className }: BadgeProps) {
  const classes = variant === 'module' && moduleId
    ? moduleColors[moduleId] ?? variantClasses.draft
    : variantClasses[variant as Exclude<BadgeVariant, 'module'>] ?? variantClasses.draft

  return (
    <span className={cn('inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full', classes, className)}>
      {children}
    </span>
  )
}
